import { all, take, put, call, takeLatest, select } from 'redux-saga/effects'
import { makeSaga } from './util'
import _ from 'lodash/fp'

import { routerActions } from 'connected-react-router'

import { getEffect, postEffect } from './network'
import { types, actions } from '../reducers/claimTokens'
import { actions as matchesActions } from '../reducers/matches'
import { selectors as profileSelectors } from '../reducers/profile'

import { mergeMatchesFlightsGamesBuddies } from './matches'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * claimEffect ({ claimToken }) {
  const request = {
    url: `/claim-tokens/take-over/${claimToken}`
  }
  const chan = yield call(postEffect, request)
  const response = yield take(chan)
  return response
}

export function * loadMatchEffect (claimToken) {
  const request = {
    url: `/games/${claimToken}`
  }
  const chan = yield call(getEffect, request)
  const response = yield take(chan)
  return response
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * claimFlow ({ payload }) {
  const response = yield call(claimEffect, payload)
  if (_.get('error', response) || _.isEmpty(response)) {
    yield put(actions.claimError())
    yield put(routerActions.replace(`/claim/${_.get('claimToken', payload)}`))
  } else {
    const gameId = _.get('game-id', response)
    const userHandle = yield select(profileSelectors.getProfileHandle)
    yield all([
      put(matchesActions.sync()),
      put(actions.claimSuccess()),
      put(routerActions.replace(`${userHandle}/games/${gameId}`))
    ])
  }
  yield put(actions.claimDone())
}

/**
 * Load a single match to display for the user before he decides
 * on claiming the thing.
 *
 * Should just merge it into matches/flights/games because why not.
 */
export function * loadMatchFlow ({ payload: { claimToken } }) {
  const response = yield call(loadMatchEffect, claimToken)

  if (_.get('error', response) || _.isEmpty(response)) {
    yield put(actions.loadMatchError())
  } else {
    const gameId = _.flow(_.get('games'), _.first, _.get('gameId'))(response)
    yield all([
      put(actions.setTokenToGameId({ claimToken, gameId })),
      call(mergeMatchesFlightsGamesBuddies, response),
      put(actions.loadMatchSuccess())
    ])
  }
  yield put(actions.loadMatchDone())
}

export default makeSaga([
  takeLatest(types.CLAIM_REQUEST, claimFlow),
  takeLatest(types.LOAD_MATCH_REQUEST, loadMatchFlow)
])
